const storePrefix = "/reservations/";

export const buildHref = (href, store, basePath, bypassBasePath) => {
	if (href[0] === "/") {
		if (store) {
			href = `${storePrefix}${store}${href}`;
		}
		if (!bypassBasePath) {
			href = `${basePath}${href}`;
		}
	}
	return href;
};
